import React, { useState } from 'react';
import { useNavigate, usseNavigate } from 'react-router-dom'
import './ChangePassword.css';
import { Box } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Modal from '../../components/Modal/Modal';

const API_URL = process.env.REACT_APP_API_URL;

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const navigate = useNavigate();
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    const handleChangeChangePassword = async (event) => {
        event.preventDefault();

        const changePassword = {
            old_password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmNewPassword,
        }

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/accounts/change-password`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                },
                body: JSON.stringify(changePassword),
            });
            if (response.ok) {
                const data = await response.json();
                setOldPassword('');
                setNewPassword('');
                setConfirmNewPassword('');
                setModalData({
                    isVisible: true,
                    message: 'رمز عبور شما با موفقیت تغییر یافت',
                    type: 'success',
                });
                const role = localStorage.getItem('role')
                const timer = setTimeout(() => {
                    navigate(`/${role}/dashboard`);
                }, 1000);
                return () => clearTimeout(timer);
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                })
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            })
        }
    };

    return (
        <div className="container">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 2,
                    width: '400px',
                    margin: '50px 0'
                }}
            >
                <h1 className="login-title">تغییر رمز عبور</h1>
                <form className="login-form" onSubmit={handleChangeChangePassword} method="post">
                    <div className="form-group">
                        <label htmlFor="old-password" className="password-label">رمز عبور قبلی</label>
                        <div className="password-wrapper">
                            <input
                                className="password-input"
                                type={showOldPassword ? 'text' : 'password'}
                                id="old-password"
                                name="password"
                                tabIndex="1"
                                value={oldPassword}
                                onChange={(event) => setOldPassword(event.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowOldPassword(!showOldPassword)}
                            >
                                {showOldPassword ? <Visibility fontSize='large' /> : <VisibilityOff fontSize='large' />}
                            </button>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="new-password" className="password-label">رمز عبور جدید</label>
                        <div className="password-wrapper">
                            <input
                                className="password-input"
                                type={showNewPassword ? 'text' : 'password'}
                                id="new-password"
                                name="password"
                                tabIndex="2"
                                value={newPassword}
                                onChange={(event) => setNewPassword(event.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                {showNewPassword ? <Visibility fontSize='large' /> : <VisibilityOff fontSize='large' />}
                            </button>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirm-new-password" className="password-label">تایید رمز عبور جدید</label>
                        <div className="password-wrapper">
                            <input
                                className="password-input"
                                type={showConfirmNewPassword ? 'text' : 'password'}
                                id="confirm-new-password"
                                name="confirm_password"
                                tabIndex="3"
                                value={confirmNewPassword}
                                onChange={(event) => setConfirmNewPassword(event.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                            >
                                {showConfirmNewPassword ? <Visibility fontSize='large' /> : <VisibilityOff fontSize='large' />}
                            </button>
                        </div>
                    </div>
                    <button
                        className="login-button medium-text"
                        type="submit"
                        tabIndex="4"
                    >
                        ثبت
                    </button>
                </form>
                <Modal
                    message={modalData.message}
                    type={modalData.type}
                    isVisible={modalData.isVisible}
                    onClose={() => setModalData({ ...modalData, isVisible: false })}
                />
            </Box>
        </div>
    );
};

export default ChangePassword;
